import { IFormattedApiError } from 'affiny-core/modules/api/core/types';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import { IRootState } from 'affiny-core/modules/state';

export const selectError = (
  state: IRootState,
  asyncEventName: EAsyncEventTypes
) => state.asynchronousState?.[asyncEventName]?.error;

export const selectErrorStatus = (error?: IFormattedApiError) => error?.status;

export const selectIsLoading = (
  state: IRootState,
  asyncEventName: EAsyncEventTypes
) => Boolean(state.asynchronousState?.[asyncEventName]?.isLoading);

export const selectAsyncState = (
  state: IRootState,
  asyncEventName: EAsyncEventTypes
) => state.asynchronousState?.[asyncEventName];

export const selectCurrentToasterKey = (state: IRootState) =>
  Object.keys(state.asynchronousState).find(
    (asyncKey: EAsyncEventTypes) =>
      state.asynchronousState?.[asyncKey]?.shouldShowToaster
  ) as EAsyncEventTypes | undefined;

/* ***** *****  Unused for now  ***** ***** */

// export const selectErrorCode = (state: IRootState) => {
//   const currentToasterKey = selectCurrentToasterKey(state);
//   return currentToasterKey
//     ? idx(state, _ => _.asynchronousState[currentToasterKey].error.code)
//     : undefined;
// };
